import { useLayoutEffect, useState } from 'react'
import Draggable from 'react-draggable'
import styled, { css } from '@xstyled/styled-components'

function getPositionOffset(defaultPositionOffset, width, direction) {
  if (defaultPositionOffset) {
    return defaultPositionOffset
  }

  const { clientWidth, clientHeight } = document.body
  const containerWidth = width ?? 0
  const x = clientWidth / 2 - containerWidth / 2
  const y = -clientHeight / 2

  switch (direction) {
    case 'rtl':
      return { x: -x, y }
    case 'ltr':
    default:
      return { x, y }
  }
}

export const DraggableWindow = ({
  children,
  handle = '.draggable-handle',
  containerProps = {},
  direction = 'ltr',
  width,
  ...rest
}) => {
  const [, forceUpdate] = useState({})
  useLayoutEffect(() => forceUpdate({}), [])

  return (
    <Draggable
      handle={handle}
      {...rest}
      positionOffset={getPositionOffset(rest.positionOffset, width, direction)}
      tabIndex={-1}
    >
      <Root w='max-content' {...containerProps} handle={handle} tabIndex={-1}>
        {children}
      </Root>
    </Draggable>
  )
}

const Root = styled.divBox`
  position: relative;
  z-index: 10000;

  &.react-draggable {
    ${({ handle }) => css`
      ${handle} {
        cursor: grab;
      }
    `}
  }

  &.react-draggable.react-draggable-dragging {
    ${({ handle }) => css`
      ${handle} {
        cursor: grabbing;
      }
    `}
  }
`
